// 서버가 "YYYY-MM-DD HH:MM:SS" 형식의 문자열로 내려주는 날짜/시간을 파싱합니다.
// Date 객체를 거치지 않기 때문에 타임존으로 인한 날짜 밀림이 발생하지 않습니다.

interface DateParts {
  y: string;
  m: string;
  d: string;
  hm: string;
}

function parseParts(value: string | null | undefined): DateParts | null {
  if (!value) return null;
  const str = String(value).trim();
  // "YYYY-MM-DD", "YYYY-MM-DD HH:MM", "YYYY-MM-DDTHH:MM" 모두 허용
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
  if (!match) return null;
  return {
    y: match[1],
    m: match[2],
    d: match[3],
    hm: match[4] && match[5] ? `${match[4]}:${match[5]}` : "",
  };
}

export function formatDate(value: string | null | undefined): string {
  const p = parseParts(value);
  if (!p) return "-";
  return `${p.y}.${p.m}.${p.d}`;
}

export function formatDateTime(value: string | null | undefined): string {
  const p = parseParts(value);
  if (!p) return "-";
  return p.hm ? `${p.y}.${p.m}.${p.d} ${p.hm}` : `${p.y}.${p.m}.${p.d}`;
}